import React, { useState, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';
import { Box, Drawer, useMediaQuery } from '@mui/material';

const drawerWidth = 240;

const Layout = ({ userName, isAuth, logout, login, theme }) => {
    const [headerShow, setHeaderShow] = useState(true);
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const [drawerOpen, setDrawerOpen] = useState(!isMobile);
    const [mobileOpen, setMobileOpen] = useState(false);

    useEffect(() => {
        setDrawerOpen(!isMobile);
    }, [isMobile]);

    const handleDrawerToggle = () => {
        if (isMobile) {
            setMobileOpen(prev => !prev);
        } else {
            setDrawerOpen(prev => !prev);
        }
    };

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', flexDirection: 'column' }}>
            <Header
                userName={userName}
                isAuth={isAuth}
                logout={logout}
                login={login}
                headerShow={headerShow}
                setHeaderShow={setHeaderShow}
                onMenuClick={handleDrawerToggle}
            />

            <Drawer
                variant={isMobile ? 'temporary' : 'persistent'}
                open={isMobile ? mobileOpen : drawerOpen}
                onClose={handleDrawerToggle}
                ModalProps={{ keepMounted: true }}
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                        top: 0,
                        height: '100%',
                        pt: {
                            xs: '140px',
                            sm: '160px',
                            md: '110px',
                        },
                    },
                }}
            >
                <Sidebar onItemClick={() => isMobile && setMobileOpen(false)} />
            </Drawer>

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    ml: !isMobile && drawerOpen ? `${drawerWidth}px` : 0,
                    pt: {
                        xs: '140px',
                        sm: '160px',
                        md: '110px',
                    },
                    px: {
                        xs: 1.5,
                        sm: 4,
                        md: 5,
                    },
                    pb: 3,
                }}
            >
                <Outlet />
            </Box>

            <Box
                component="footer"
                sx={{
                    ml: !isMobile && drawerOpen ? `${drawerWidth}px` : 0,
                    px: {
                        xs: 1.5,
                        sm: 4,
                        md: 5,
                    },
                    py: 3,
                }}
            >
                <Footer />
            </Box>
        </Box>
    );
};

export default Layout;